import axios from 'axios'

export function getAboutPage(locale) {
  return axios({ method: 'GET', url: 'api/sales-static/about', params: { locale } })
}
